

export function checkVisibility(id, type) {
    if (type !== "partner" && type !== "officeEmployee") {
        console.error(`visibility type ${type} not supported`)
        return true;
    }

    if (id === null) {
        console.warn(`${type} id null`);
        return true;
    }

    if (id === undefined) {
        console.error(`${type} id undefined`);
        return true;
    }

    const key = type + id.toString();
    const val = localStorage.getItem(key);
    if (val === null) {
        // not in local storage, save as visible
        localStorage.setItem(key, "1");
        return true;
    }

    if (val !== "0" && val !== "1") {
        console.error(`saved value ${val} not supported`)
        return true;
    }

    return Boolean(Number(val));
}


export function setVisibility(key, visibility) {
    localStorage.setItem(key, visibility.toString());
}


export function switchVisibility(id, type) {
    if (type !== "partner" && type !== "officeEmployee") {
        console.error(`visibility type ${type} not supported`)
        return;
    }
    const val = checkVisibility(id, type);
    const key = type + id.toString();
    setVisibility(key, (val+1)%2);
}


// supported in browser
const viewableExtensions = new Set([
    'pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'txt', 'html', 'json', 'xml', 'mp3', 'mp4'
]);


export function canViewByExtension(filename) {
    const ext = filename.split('.').pop().toLowerCase();
    return viewableExtensions.has(ext);
}
